import router from './router/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getCookie } from '@/utils/auth'
NProgress.configure({ showSpinner: false })
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    NProgress.start()
    document.title = '👸专用';
    if (to.name !== 'login' && !getCookie('xypCookie')){
        next({ name: 'login' })
        NProgress.done()
    }else {
        next()
        NProgress.done()
    }
})
router.afterEach(() => {
    NProgress.done()
})
